import profileTypes from '../../../../../data/ProfileType.json';

export const REPRESENTATION_TYPE_OPTIONS = [
  { key: 'Agency Representation', value: 'Agency Representation' },
  {
    key: 'Non-Represented',
    value: 'Non-Represented',
  },
];

export const REPRESENTATION_TYPE_COUNTRY = [
  { value: 'United States', key: 'United States' },
  { value: 'Australia', key: 'Australia' },
];

export const REPRESENTATION_PROFILE_TYPES = profileTypes;
